import _ForgotPassword from './ForgotPassword';
export { _ForgotPassword as ForgotPassword };
import _LogIn from './LogIn';
export { _LogIn as LogIn };
import _LogOut from './LogOut';
export { _LogOut as LogOut };
import _ResetPassword from './ResetPassword';
export { _ResetPassword as ResetPassword };
import _Register from './Register';
export { _Register as Register }; // eslint-disable-next-line import/no-named-as-default

import _NoAccess from './NoAccess';
export { _NoAccess as NoAccess };
import _Verification from './Verification';
export { _Verification as Verification };